import { CollectionChangedContext, CollectionChangedJoinPointContext, ModelBase, ObservableCollection } from '@skylab-shared/core';
import { Constructor } from '@skylab-shared/types';

type Handler = (ctx: CollectionChangedJoinPointContext) => void;

type HandlerWithFiltering = (ctx: CollectionChangedJoinPointContext) => void;

export const collectionChangedJoinPointFilter = (sender: any) => <TItem extends ModelBase>(collection: ObservableCollection<TItem>) => (handler: Handler): HandlerWithFiltering => {
    return (ctx: CollectionChangedJoinPointContext): void => {
        if (ctx.sender === sender && ctx.collection === collection) {
            handler(ctx);
        }
    };
};

export const collectionChangedFilter = <TModel extends ModelBase>(
    type: Constructor<TModel>,
    property: keyof TModel,
    handler: (ctx: CollectionChangedContext<TModel>) => void
): (ctx: CollectionChangedContext<TModel>) => void => {
    return ctx => {
        if (ctx.model instanceof type && ctx.propertyName === property) {
            handler(ctx);
        }
    };
};
